import * as React from "react"

interface IProps {
  transactionType: string
}

export default function RateCalculator({ transactionType }: IProps) {
  return (
    <div
      className="UIRateCalculator JourneyRates"
      data-caption={`Check today's rates`}
      data-collapsible="true"
      data-disable-price-guarantee-banner="true"
      data-disable-cta="true"
      data-default-transaction-type={transactionType}
    />
  )
}
